<template>
    <div>
        <div class="w-100 text-center bg-secondary mt-3 mb-2 text-center" hidden>
            <h3 class="py-2">Credit Balance: RM {{ this.auth_user.subscription.scrb_credit_points }}</h3>
        </div>
        <div class="py-3">
            <h3>Credit Report</h3>
        </div>
        <div>
            <b-row class="d-flex justify-content-between align-items-top mb-3">
                <b-col md="6" cols="12">
                    <div>
                        <el-button class="bg-primary text-white"
                            @click="$refs.preview_modal.preview('https://fintos-public.s3.ap-southeast-1.amazonaws.com/Standard+COMPANY+Consent+Form+(CBM+%26+CTOS+FAIR+Copy+07.05.2024).pdf')">
                            View CTOS SME Sample Form
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 512 512">
                                <path fill="currentColor"
                                    d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v242.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352zm368 56a24 24 0 1 1 0 48a24 24 0 1 1 0-48" />
                            </svg>
                        </el-button>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div>
            <b-row class="mb-5">
                <b-col md="6" cols="12">
                    <p class="font-weight-500">Consent Form</p>
                    <vue-dropzone id="consentFormDropzone" ref="consentFormDropzone" :useCustomSlot=true
                        :options="dropzoneOptions" v-model="form.consent_form"
                        v-on:vdropzone-error="dropzoneErrorConsentForm"
                        v-on:vdropzone-file-added="dropzoneAddedConsentForm"
                        v-on:vdropzone-removed-file="dropzoneRemovedConsentForm">
                        <b-icon icon="cloud-arrow-up-fill" font-scale="4"></b-icon>
                        <p class="mb-0">Drag and Drop Upload or</p>
                        <el-button type="text">Click to Browse</el-button>
                    </vue-dropzone>
                    <small class="text-muted">Please upload your consent form</small>
                </b-col>
                <b-col md="6" cols="12">
                    <b-row>
                        <b-col md="6" cols="12">
                            <p class="font-weight-500">IC Front</p>
                            <vue-dropzone id="frontNRICDropzone" ref="frontNRICDropzone" :options="dropzoneOptionsImage"
                                :useCustomSlot=true v-model="form.front_nric"
                                v-on:vdropzone-error="dropzoneErrorFrontNRIC"
                                v-on:vdropzone-file-added="dropzoneAddedFrontNRIC"
                                v-on:vdropzone-removed-file="dropzoneRemovedFrontNRIC">
                                <b-icon icon="cloud-arrow-up-fill" font-scale="4"></b-icon>
                                <p class="mb-0">Drag and Drop Upload or</p>
                                <el-button type="text">Click to Browse</el-button>
                            </vue-dropzone>
                            <small class="text-muted">Please upload your IC front</small>
                        </b-col>
                        <b-col md="6" cols="12">
                            <p class="font-weight-500">IC Back</p>
                            <vue-dropzone id="backNRICDropzone" ref="backNRICDropzone" :options="dropzoneOptionsImage"
                                :useCustomSlot=true v-model="form.back_nric"
                                v-on:vdropzone-error="dropzoneErrorBackNRIC"
                                v-on:vdropzone-file-added="dropzoneAddedBackNRIC"
                                v-on:vdropzone-removed-file="dropzoneRemovedBackNRIC">
                                <b-icon icon="cloud-arrow-up-fill" font-scale="4"></b-icon>
                                <p class="mb-0">Drag and Drop Upload or</p>
                                <el-button type="text">Click to Browse</el-button>
                            </vue-dropzone>
                            <small class="text-muted">Please upload your IC back</small>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div>
                <div style="margin-left: -15px">
                    <b-col md="6" cols="12">
                        <b-form-group label="Business entity registration category:" class="font-weight-500">
                            <el-select v-model="form.credit_report_type" placeholder="SELECT STATE" filterable>
                                <el-option v-for="category in categoryList" :key="category.id" :label="category.name"
                                    :value="category.value">
                                </el-option>
                            </el-select>
                            <small class="text-muted">Please select business entity registration category.</small>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" cols="12">
                        <b-form-group label="CCM (SSM) Source Date:" class="font-weight-500">
                            <el-select v-model="form.credit_report_custom_identifier" placeholder="SELECT OPTION"
                                filterable>
                                <el-option v-for="source in sourceDateList" :key="source.id" :label="source.value"
                                    :value="source.value">
                                </el-option>
                            </el-select>
                            <small class="text-muted">Please select company type.</small>
                        </b-form-group>
                    </b-col>
                </div>

                <b-row>
                    <b-col md="6" cols="12">
                        <div class="form-group">
                            <label for="company_name" class="form-label font-weight-500">Company Name <span
                                    class="text-danger">*</span></label>
                            <input type="text" class="form-control" placeholder="Company Name" id="company_name"
                                required v-model="form.credit_report_comp_name">
                            <small class="text-muted">Please enter company name</small>
                        </div>
                    </b-col>
                    <b-col md="6" cols="12">
                        <div class="form-group">
                            <label for="company_reg_no" class="form-label font-weight-500">Company Reg No. <span
                                    class="text-danger">*</span> </label>
                            <input type="text" class="form-control" placeholder="Company Reg No." id="company_reg_no"
                                required v-model="form.credit_report_comp_reg">
                            <small class="text-muted">Please enter company reg no</small>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" cols="12">
                        <div class="form-group">
                            <label for="company_owner_name" class="form-label font-weight-500">Company Owner Name <span
                                    class="text-danger">*</span> </label>
                            <input type="text" class="form-control" placeholder="Company Owner Name"
                                id="company_owner_name" required v-model="form.credit_report_cust_name">
                            <small class="text-muted">Please enter company Owner name</small>
                        </div>
                    </b-col>
                    <b-col md="6" cols="12">
                        <div class="form-group">
                            <label for="company_owner_ic" class="form-label font-weight-500">Company Owner IC <span
                                    class="text-danger">*</span> </label>
                            <input type="text" class="form-control" placeholder="Company Owner IC" id="company_owner_ic"
                                required maxlength="12" v-model="form.credit_report_cust_ic">
                            <small class="text-muted">Please enter company Owner IC</small>
                        </div>
                    </b-col>
                </b-row>
                <b-form-group>
                    <p class="font-weight-500">Normal SME Report - RM {{ sme_normal_price | moneyFormatter }}</p>
                </b-form-group>
                <hr class="hr my-3">
                <p class="font-weight-500">Chargeable Add-On</p>
                <hr class="hr my-3">
                <b-form-group>
                    <b-form-checkbox id="lg" v-model="form.credit_report_lg_guarantor" name="lg" value=1
                        unchecked-value=0>
                        <p class="font-weight-500">L.G.- Liabilities as Guarantor
                            <el-tooltip content="Total amount guaranteed by the subject." placement="bottom">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512">
                                    <path fill="#5867dd"
                                        d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512m-86.2-346.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0a32 32 0 1 1-64 0" />
                                </svg>
                            </el-tooltip>
                            RM {{ sme_addons.sme_lg_guarantor_price | moneyFormatter }}
                        </p>
                    </b-form-checkbox>
                </b-form-group>
                <b-form-group>
                    <b-form-checkbox id="creditReportCcris" v-model="form.credit_report_ccris" name="instalment" value=1
                        unchecked-value=0>
                        <p class="font-weight-500">CCRIS Suplementary
                            <el-tooltip placement="bottom">
                                <template #content>
                                    <div class="text-center" style="max-width: 200px">
                                        This report provides information on the addresses, telephone numbers, employer's
                                        name, and occupation of the customer as provided by other PFIs (Participating
                                        Financial Institutions) for the last 3 years.
                                    </div>
                                </template>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512">
                                    <path fill="#5867dd"
                                        d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512m-86.2-346.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0a32 32 0 1 1-64 0" />
                                </svg>
                            </el-tooltip>
                            RM {{ sme_addons.sme_ccris_price | moneyFormatter }}
                        </p>
                    </b-form-checkbox>
                </b-form-group>
                <b-form-group>
                    <b-form-checkbox id="angkasa" v-model="form.credit_report_angkasa" name="angkasa" value=1
                        unchecked-value=0>
                        <p class="font-weight-500">Angkasa
                            <el-tooltip placement="bottom">
                                <template #content>
                                    <div class="text-center" style="max-width: 200px">
                                        This report provides information on the addresses, telephone numbers, employer's
                                        name, and occupation of the customer as provided by other PFIs (Participating
                                        Financial Institutions) for the last 3 years.
                                    </div>
                                </template>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512">
                                    <path fill="#5867dd"
                                        d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512m-86.2-346.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0a32 32 0 1 1-64 0" />
                                </svg>
                            </el-tooltip>
                            RM {{ sme_addons.sme_angkasa | moneyFormatter }}
                        </p>
                    </b-form-checkbox>
                </b-form-group>
            </div>

            <hr class="hr my-3">

            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <p class="font-weight-500">Partner <span class="text-sm">(RM 15 each)</span></p>
                    <small class="text-danger">*Limited to 5 Business Owners per search</small>
                </div>
                <div>
                    <p class="text-primary cursor-pointer" @click="addPartner">Add Partner <svg
                            xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 448 512">
                            <path fill="currentColor"
                                d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256z" />
                        </svg></p>
                </div>
            </div>

            <hr class="hr my-3">
            <div>
                <b-col md="8" cols="12">
                    <b-table-simple borderless responsive>
                        <b-tbody>
                            <b-tr v-for="(partner, index) in form.credit_report_partner_json" :key="index">
                                <b-td width="10%">
                                    <p class="font-weight-500">RM 15</p>
                                    <p @click="removePartner(index)" class="text-primary cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                                            viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                d="M432 256c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h352c17.7 0 32 14.3 32 32" />
                                        </svg>
                                    </p>
                                </b-td>
                                <b-td style="min-width: 250px">
                                    <p class="font-weight-500">Full Name</p>
                                    <input type="text" class="form-control" placeholder="Enter Name as per IC"
                                        v-model="form.credit_report_partner_json[index].partner_name">
                                </b-td>
                                <b-td style="min-width: 200px">
                                    <p class="font-weight-500">IC No</p>
                                    <input type="text" class="form-control" placeholder="Enter IC" maxlength="12"
                                        @keydown="preventNonNumericInput"
                                        v-model="form.credit_report_partner_json[index].partner_ic">
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </div>

            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <p class="font-weight-500">TOTAL: <span class="text-danger">RM {{ total_amount | moneyFormatter
                            }}</span></p>
                    <!-- <el-button type="text" class="btn btn-outline-danger" variant="primary" @click="$refs.preview_modal.preview('https://sas.imortgage2u.com/portal/download_files/CTOS-Consent-Form-Techapp-V2.pdf')">Pending</el-button> -->
                    <!-- <el-button type="danger" plain @click="$refs.preview_modal.preview('https://sas.imortgage2u.com/portal/download_files/CTOS-Consent-Form-Techapp-V2.pdf')">Pending</el-button> -->
                </div>
                <div>
                    <el-button class="bg-primary text-white" @click="addReport"
                        v-loading.fullscreen.lock="fullscreenLoading">
                        Confirm Purchase
                    </el-button>
                </div>
            </div>
        </div>

        <PreviewModal ref="preview_modal"></PreviewModal>
    </div>
</template>

<script>
import vue2Dropzone, { methods } from 'vue2-dropzone'
import { Select, Option, Button } from 'element-ui'
import { notifyFunctionMixin, axios, services, getHeader, swal, helperFunctionMixin } from '@/assets/js/httpImports.js'
import { useAuthStore } from '@/stores/authStore'
import { useFintscoreStore } from '@/stores/fintscoreStore'
import { mapState } from 'pinia'
import PreviewModal from '@/components/Modal/PreviewModal.vue'

export default {
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        vueDropzone: vue2Dropzone,
        PreviewModal,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
    },
    data() {
        return {
            fullscreenLoading: false,
            dropzoneOptions: {
                url: '#',
                addRemoveLinks: true,
                maxFiles: 1,
                autoProcessQueue: false,
                acceptedFiles: "application/pdf,image/jpeg,image/png",
            },
            dropzoneOptionsImage: {
                url: '#',
                addRemoveLinks: true,
                maxFiles: 1,
                autoProcessQueue: false,
                acceptedFiles: "image/jpeg,image/png",
            },
            categoryList: [
                {
                    id: 1,
                    name: 'Company',
                    value: 'company'
                },
            ],
            sourceDateList: [
                {
                    id: 1,
                    value: 'Real-Time/Live (Chargeable Add On) +RM12'
                },
                {
                    id: 2,
                    value: 'CTOS Archive'
                },
            ],
            initial_form_values: {},
            form: {
                credit_report_scrb_id: '',
                credit_report_platform: 'CTOS',
                credit_report_generate_payment: 1,
                credit_report_type: 'company',
                credit_report_comp_type: 'Company',
                credit_report_comp_name: '',
                credit_report_comp_reg: '',
                credit_report_cust_name: '',
                credit_report_cust_ic: '',
                credit_report_angkasa: 0,
                credit_report_ccris: 0,
                credit_report_lg_guarantor: 0,
                credit_report_ssm: 0,
                credit_report_custom_identifier: '',
                credit_report_partner_json: [
                ],
                credit_report_conset_content: '',
                credit_report_ic_front_content: '',
                credit_report_ic_back_content: '',
                test_mode: _gAuth.appIsDemo()

            },
        }
    },
    mounted() {
        this.initForm()
    },
    computed: {
        ...mapState(useFintscoreStore, ['sme_normal_price', 'sme_addons']),
        total_amount() {
            let total = this.sme_normal_price
            if (this.form.credit_report_custom_identifier == 'Real-Time/Live (Chargeable Add On) +RM12') total += 12
            if (this.form.credit_report_lg_guarantor == 1) total += this.sme_addons.sme_lg_guarantor_price
            if (this.form.credit_report_ccris == 1) total += this.sme_addons.sme_ccris_price
            if (this.form.credit_report_angkasa == 1) total += this.sme_addons.sme_angkasa
            if (this.form.credit_report_partner_json.length > 0) total += this.form.credit_report_partner_json.length * 15

            return total
        },
        ...mapState(useAuthStore, ['auth_user']),
    },
    methods: {
        addPartner() {
            if (this.form.credit_report_partner_json.length > 4) {
                swal.fire({ title: 'Error', text: 'You have reached maximum number of Business Owners (5)', icon: 'error' })
            } else {
                swal.fire({
                    title: "Attention",
                    text: "Please ensure that you have collected the consent from your business partner",
                    icon: "info",
                    confirmButtonText: `
                        Confirm
                        `,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.form.credit_report_partner_json.push({
                            partner_name: '',
                            partner_ic: ''
                        })
                    }
                });
            }
        },
        removePartner(id) {
            this.form.credit_report_partner_json.splice(id, 1)
        },
        async addReport() {
            this.fullscreenLoading = true

            if (this.form.credit_report_partner_json) {
                this.form.credit_report_partner_json = this.form.credit_report_partner_json.filter((obj) => (obj.partner_name && obj.partner_ic) != '')
            }

            let base64_consent_form = null
            if (this.form.consent_form) {
                base64_consent_form = await this.convertFileToBase64(this.form.consent_form);
            }

            let base64_front_nric = null
            if (this.form.front_nric) {
                base64_front_nric = await this.convertFileToBase64(this.form.front_nric);
            }

            let base64_back_nric = null
            if (this.form.back_nric) {
                base64_back_nric = await this.convertFileToBase64(this.form.back_nric);
            }

            this.form.credit_report_conset_content = base64_consent_form
            this.form.credit_report_ic_front_content = base64_front_nric
            this.form.credit_report_ic_back_content = base64_back_nric

            this.form.credit_report_scrb_id = this.auth_user.subscription.scrb_id
            this.form.credit_report_partner_json = JSON.stringify(this.form.credit_report_partner_json);
            var host = window.location.protocol + "//" + window.location.host;
            this.form.credit_report_redirect_url = host + '/sme-reports';
            if (this.form.credit_report_custom_identifier == 'Real-Time/Live (Chargeable Add On) +RM12') {
                this.form.credit_report_ssm = 1
            } else {
                this.form.credit_report_ssm = 0
            }

            axios.post(services.commitment + '/credit-report', this.form, { headers: getHeader() })
                .then(res => {
                    location.href = res.data.pay_url
                    this.$emit('refresh')
                    this.notifySuccess('<b>SME Reports</b> - Successfully Created.')
                    this.resetForm()
                    this.removePartners()
                    this.fullscreenLoading = false
                })
                .catch(e => {
                    this.fullscreenLoading = false
                    this.errorFunction(e)
                })
        },
        initForm() {
            this.initial_form_values = { ...this.form };
        },
        resetForm() {
            if (!_gHlp.isEmpty(this.$refs.consentFormDropzone)) this.$refs.consentFormDropzone.removeAllFiles();
            if (!_gHlp.isEmpty(this.$refs.frontNRICDropzone)) this.$refs.frontNRICDropzone.removeAllFiles();
            if (!_gHlp.isEmpty(this.$refs.backNRICDropzone)) this.$refs.backNRICDropzone.removeAllFiles();
            this.form = { ...this.initial_form_values };
        },
        dropzoneErrorConsentForm(file, error, xhr) {
            this.form.consent_form = null
        },
        dropzoneAddedConsentForm(file) {
            if (this.$refs.consentFormDropzone.dropzone.files.length > 1) {
                const [existingFile] = this.$refs.consentFormDropzone.dropzone.files;
                this.$refs.consentFormDropzone.dropzone.removeFile(existingFile);
            }
            this.form.consent_form = file;
        },
        dropzoneRemovedConsentForm(file, error, xhr) {
            this.form.consent_form = null
        },
        dropzoneErrorFrontNRIC() {
            this.form.front_nric = null
        },
        dropzoneAddedFrontNRIC(file) {
            if (this.$refs.frontNRICDropzone.dropzone.files.length > 1) {
                const [existingFile] = this.$refs.frontNRICDropzone.dropzone.files;
                this.$refs.frontNRICDropzone.dropzone.removeFile(existingFile);
            }
            this.form.front_nric = file
        },
        dropzoneRemovedFrontNRIC(file, error, xhr) {
            this.form.front_nric = null
        },
        dropzoneErrorBackNRIC(file, error, xhr) {
            this.form.back_nric = null
        },
        dropzoneAddedBackNRIC(file) {
            if (this.$refs.backNRICDropzone.dropzone.files.length > 1) {
                const [existingFile] = this.$refs.backNRICDropzone.dropzone.files;
                this.$refs.backNRICDropzone.dropzone.removeFile(existingFile);
            }
            this.form.back_nric = file
        },
        dropzoneRemovedBackNRIC(file, error, xhr) {
            this.form.back_nric = null
        },
        async convertFileToBase64(file) {
            if (file.length != 0) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = reject;
                });
            } else {
                return ''
            }
        },
        removePartners() {
            this.form.credit_report_partner_json = [{ partner_name: '', partner_ic: '' }]
        },
    }
}
</script>

<style>
.dropzone .dz-message {
    margin: 0;
}

.dz-message {
    padding: 0;
}

#consentFormDropzone.dropzone .dz-preview .dz-progress {
    display: none !important
}

.dz-preview .dz-error-message {
    top: 0px !important;
}
</style>